import { useEffect, useState, useCallback } from "react";
import api, { errMsg } from "../lib/api";
import { PageHeader, Card, Badge, Modal, Btn, Field, inputCls } from "../components/common";
import { toast } from "sonner";
import { Plus, TicketPercent } from "lucide-react";
import { fmtDate } from "../lib/format";

export default function ReferralSales() {
  const [rows, setRows] = useState([]);
  const [report, setReport] = useState([]);
  const [sales, setSales] = useState([]);
  const [addOpen, setAddOpen] = useState(false);
  const [form, setForm] = useState({ code: "", sales_id: "", valid_from: "", valid_until: "" });

  const load = useCallback(() => {
    api.get("/marketing/referral-codes").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get("/marketing/referral-report").then((r) => setReport(r.data)).catch(() => {});
    api.get("/users").then((r) => setUsersFilter(r.data)).catch(() => {});
  }, []);
  const setUsersFilter = (all) => setSales(all.filter((u) => u.role === "Sales" && u.active !== false));
  useEffect(() => { load(); }, [load]);

  const create = () => {
    if (!form.code.trim() || !form.sales_id) return toast.error("Kode & sales wajib diisi");
    api.post("/marketing/referral-codes", { ...form, valid_from: form.valid_from || null, valid_until: form.valid_until || null })
      .then(() => { toast.success("Kode referral dibuat"); setAddOpen(false); setForm({ code: "", sales_id: "", valid_from: "", valid_until: "" }); load(); })
      .catch((e) => toast.error(errMsg(e)));
  };
  const toggle = (r) => api.put(`/marketing/referral-codes/${r.id}`, { active: !r.active })
    .then(() => { toast.success("Status diubah"); load(); }).catch((e) => toast.error(errMsg(e)));

  const rep = Object.fromEntries(report.map((r) => [r.code, r]));
  return (
    <div data-testid="referral-page">
      <PageHeader title="Kode Referral Sales" subtitle="Kode unik per sales untuk aplikasi ABAD JAYA LIVING (awalan AJL- khusus kode konsumen)" testid="referral-header">
        <Btn onClick={() => setAddOpen(true)} data-testid="referral-add-btn"><Plus className="w-4 h-4" /> Buat Kode</Btn>
      </PageHeader>

      <div className="space-y-2" data-testid="referral-list">
        {rows.length === 0 && <Card><p className="text-slate-500 text-sm">Belum ada kode referral.</p></Card>}
        {rows.map((r) => {
          const rp = rep[r.code] || {};
          return (
            <Card key={r.id} className="!p-4" testid={`referral-${r.id}`}>
              <div className="flex flex-wrap items-center gap-2">
                <TicketPercent className="w-4 h-4 text-emerald-400 shrink-0" />
                <span className="font-mono font-medium text-slate-200">{r.code}</span>
                <Badge tone={r.active ? "emerald" : "slate"}>{r.active ? "Aktif" : "Nonaktif"}</Badge>
                {(r.valid_from || r.valid_until) && (
                  <span className="text-[11px] text-slate-500">{fmtDate(r.valid_from)} — {r.valid_until ? fmtDate(r.valid_until) : "∞"}</span>
                )}
                <button onClick={() => toggle(r)} className="ml-auto text-xs text-amber-300 hover:underline" data-testid={`referral-toggle-${r.id}`}>
                  {r.active ? "Nonaktifkan" : "Aktifkan"}
                </button>
              </div>
              <div className="text-[11px] text-slate-500 mt-1">{r.sales_name} · {r.sales_phone || "-"}</div>
              <div className="flex gap-1.5 mt-2">
                <Badge tone="cyan">Pendaftar: {rp.pendaftar ?? 0}</Badge>
                <Badge tone="amber">Booking: {rp.booking ?? 0}</Badge>
                <Badge tone="emerald">Akad: {rp.akad ?? 0}</Badge>
              </div>
            </Card>
          );
        })}
      </div>

      <Modal open={addOpen} onClose={() => setAddOpen(false)} title="Buat Kode Referral Sales" testid="referral-modal">
        <div className="space-y-3">
          <Field label="Kode unik (tanpa awalan AJL-)">
            <input className={inputCls} value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="BUDI26" data-testid="referral-code-input" />
          </Field>
          <Field label="Sales pemilik kode">
            <select className={inputCls} value={form.sales_id} onChange={(e) => setForm({ ...form, sales_id: e.target.value })} data-testid="referral-sales-select">
              <option value="">— pilih sales —</option>
              {sales.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </Field>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Berlaku dari (opsional)"><input type="date" className={inputCls} value={form.valid_from} onChange={(e) => setForm({ ...form, valid_from: e.target.value })} data-testid="referral-from" /></Field>
            <Field label="Berlaku sampai (opsional)"><input type="date" className={inputCls} value={form.valid_until} onChange={(e) => setForm({ ...form, valid_until: e.target.value })} data-testid="referral-until" /></Field>
          </div>
          <Btn onClick={create} data-testid="referral-create-btn">Simpan Kode</Btn>
        </div>
      </Modal>
    </div>
  );
}
